import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { getAuthCredentials } from "../../../utils/auth";

const CompileLooseleafModal = ({ open, onClose }) => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const { token, user } = getAuthCredentials();
  const posId = user?.posId;

  const handleGenerate = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates.");
      return;
    }

    if (!posId) {
      alert("POS ID not found.");
      return;
    }

    setLoading(true);
    try {
      const startUTC = new Date(startDate + "T00:00:00.000Z").toISOString();
      const endUTC = new Date(endDate + "T23:59:59.999Z").toISOString();

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api/receipt/compile-looseleaf`,
        { startDate: startUTC, endDate: endUTC, posId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );

      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/zip",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Looseleaf_${startDate}_to_${endDate}.zip`;
        link.click();
        alert("Looseleaf ZIP generated successfully.");
      }
    } catch (error) {
      console.error("Error generating Looseleaf ZIP:", error);
      alert("Failed to generate Looseleaf ZIP. Please try again.");
    } finally {
      setLoading(false);
      onClose();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Generate Looseleaf ZIP</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ marginBottom: 2 }}>
          Please select the date range to compile all receipts:
        </Typography>
        <TextField
          label="Start Date"
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />
        <TextField
          label="End Date"
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleGenerate}
          variant="contained"
          color="primary"
          disabled={loading}
        >
          {loading ? (
            <CircularProgress size={22} color="inherit" />
          ) : (
            "Generate"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompileLooseleafModal;
